import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { Box, chakra } from "@chakra-ui/react";

export const CollegeAccordion = () => {
  return (
    <Accordion allowMultiple>
      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF">
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How can I upload my essays?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              It's a really easy process! Create an account with us and fill in all the required
              input fields. This should take you fewer than five minutes. Then, you can either
              upload PDFs of your Common Application (and we'll automatically read through it and
              fill out all the information), or manually upload your essays to your profile. We've
              done everything we can to make this hassle-free!
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  I'm concerned about plagiarism. What if someone copies my essay?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              For years, college students have shared their application essays with close friends
              and in online communities. There have been no problems with that system, and AdmitYogi
              is no different; we’re simply taking a longstanding practice and making it easier to
              share. AdmitYogi disables copying and printing from profiles to prevent plagiarism.
              However, if a student does somehow plagiarize an essay, it is that student—not you—who
              will get in trouble. Colleges have plagiarism detection software for this very
              purpose. We unequivocally condemn plagiarism and want to make sure that you feel
              comfortable uploading your essays onto our platform. If you have any additional
              questions, please reach out to us! We’re here to meet your needs.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  I'm concerned about putting my entire college application up on the Internet for
                  anyone to view. Is AdmitYogi anonymous?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Sharing your college essays is deeply personal — we get that! That’s why we offer
              several features to help you choose what you’d like to share and not share on our
              platform. Our customizable usernames let you set your profile name to whatever you
              choose. Our redact feature allows you to remove any immediately identifiable
              information, like the exact name of that organization you started or that debate
              tournament you won. Finally, we’d like to emphasize that you are in the driver’s seat.
              You get to choose what information you do (and don’t) share. If you would like to hide
              an essay, that is entirely your prerogative! Ultimately, what you include on your
              AdmitYogi profile is up to you.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  Should my username match my real name?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Nope, it doesn't have to! We understand that you may want the anonymity of a screen
              name, so you can pick a display name that makes you comfortable. However, having a
              profile with your own name—rather than a less-specific username—may make your account
              feel more personal, and it may increase the chances that a student unlocks your
              profile.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How do I make money?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Your earnings on AdmitYogi are based on a revenue share model, depending on the
              quality of your profile. Every time a student purchases access to your profile, we
              calculate your share based on the profile's attractiveness and quality. It's passive
              income for you!
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How do I withdraw site earnings?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              In your Account Dashboard, click Request Payouts. We'll send you money to your
              Venmo/PayPal in the next 2-4 business days!
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  Can I refer friends, and are there any incentives for referrals?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Yep! Check out your User Dashboard and click the Referral tab for more info.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  I'm having trouble setting up an account. What do I do?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              While this issue is rare, here are a few things you should try to do. First off, make
              sure you’re on your laptop or a similarly-sized device. Signing up will not work on
              your phone because the dimensions are too small! You can also try clearing your cache;
              this should reset the website data for you and hopefully resolve your issue. If
              neither of those works, reach out to us via email at{" "}
              <a href="mailto:contact@admityogi.com">contact@admityogi.com</a>. We’ll work on
              helping you set up an account. Thanks!
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How can I increase the number of unlocks (and earnings) on my profile?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Here are some recommendations that work well for some of our most unlocked profiles:{" "}
              <p style={{ marginLeft: 10 }}>
                1. Make sure that your profile is as complete as possible - our users love authentic
                and informative accounts that have verified acceptances and an abundance of essays
                and other materials.
              </p>
              <p style={{ marginLeft: 10 }}>
                2. Add more Q&A - this is also a great boost to profile attractiveness. If you are
                hesitating, just think about what would you tell your younger self and what would
                you change in your college admissions process.
              </p>
              <p style={{ marginLeft: 10 }}>
                3. Share your profile out there - we are proud of every student who joins us, and we
                want you to be proud of your account, too. Please share your page on social media
                pages, put the link in your bio, or post it with the tag @admityogi. We will boost
                your posts with our reposts, likes, and comments!
              </p>
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>
    </Accordion>
  );
};
